import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ROUTES_CONFIG } from "@/config/routes.config";
import { useTRPC } from '@/trpc';
import { useMutation } from "@tanstack/react-query";
import { TRPCClientError } from "@trpc/client";
import React from 'react'
import { toast } from "sonner";
import * as Icons from "lucide-react";

interface Props {
  invite_id: string;
  trigger?: React.ReactNode;
  onSuccess?: () => void;
}

const ResendUserInvitation = ({ invite_id, trigger, onSuccess }: Props) => {
  const { trpc } = useTRPC();
  const [open, setOpen] = React.useState(false);

  const inviteMutation = useMutation({
    mutationFn: async () => {
      const invitation = await trpc.users.sendInvitation.mutate({
        invite_id: invite_id
      });
      return invitation;
    },
    onSuccess: () => {
      onSuccess?.()
    },
    onError: (err) => {
      if(err instanceof Error) {
        toast.error(err.message)
      } else if(err instanceof TRPCClientError) {
        toast.error(err.message)
      } else {
        toast.error("Er is een onbekende fout opgetreden")
      }
    }
  })

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        {trigger}
      </AlertDialogTrigger>
      <AlertDialogContent>
        {inviteMutation?.isSuccess
        ?
        <>
        <AlertDialogHeader>
            <AlertDialogTitle>Gebruiker uitgenodigd!</AlertDialogTitle>
            <AlertDialogDescription>Verstuur onderstaande link naar de gebruiker om de uitnodiging te accepteren</AlertDialogDescription>
        </AlertDialogHeader>
        <div>
            <div className="flex items-center gap-2">
                <Input 
                    defaultValue={`${window.location.origin}${ROUTES_CONFIG.AUTH.REGISTER.$buildPath({ searchParams: { token:inviteMutation.data?.token } })}`}
                />
                <Button 
                  onClick={()=>{ 
                    navigator.clipboard.writeText(`${window.location.origin}${ROUTES_CONFIG.AUTH.REGISTER.$buildPath({ searchParams: { token:inviteMutation.data?.token } })}`) 
                    toast.success("Link gekopieerd naar klembord")
                  }}
                  variant='outline' 
                >
                  <Icons.Copy className="w-4 h-4"/>
                </Button>
            </div>
        </div>
        <AlertDialogFooter>
            <AlertDialogCancel>Sluiten</AlertDialogCancel>
        </AlertDialogFooter>
        </>
        :
        <>
        <AlertDialogHeader>
          <AlertDialogTitle>Verzend uitnodiging</AlertDialogTitle>
          <AlertDialogDescription>Wil je de uitnodiging opnieuw versturen?</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Annuleren</AlertDialogCancel>
          <Button onClick={()=>{ inviteMutation.mutate() }} disabled={inviteMutation.isLoading}>
            {inviteMutation.isLoading && <Icons.Loader2 className="w-4 h-4 animate-spin" />}
            Verstuur
          </Button>
        </AlertDialogFooter>
        </>
        }
        
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default ResendUserInvitation